<template>
  <div
    class="w-full flex bg-grey-1 cursor-pointed hover:bg-blue-2 md:rounded-lg shadow-md my-2 transition-bg transition-250 | channel-thread-item channel-thread-loading-item"
  >
    <div
      class="flex items-center justify-center px-2 py-2 md:px-4 bg-grey-2 transition-bg transition-250 md:rounded-l-lg | channel-thread-item-avatar channel-thread-loading-item-avatar"
    >
      <content-placeholders class="w-full h-full flex items-center border-0">
        <content-placeholders-img class="border rounded-full border-yellow-6 relative w-12 h-12 md:w-16 md:h-16" />
      </content-placeholders>
    </div>
    <div class="flex-1 flex flex-col justify-center px-2 py-2 ml-2 | channel-thread-loading-item-content">
      <content-placeholders class="w-full" :rounded="true">
        <content-placeholders-text :lines="2" />
      </content-placeholders>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChannelThreadLoadingItem"
}
</script>

<style lang="scss" scoped>
</style>
